import React from 'react';
import Header from '../components/Header';
import { database } from '../config';
import ToggleButton from 'react-toggle-button';
import axios from 'axios';
class Game extends React.Component {
  constructor() {
    super();
    this.state = {
      general: [],
      currentGame: [],
      message: '',
      video: ''
    }
    var currentQuestionId;
    this.startStopGame = this.startStopGame.bind(this);
    this.startStopStream = this.startStopStream.bind(this);
    this.sendMessage = this.sendMessage.bind(this);
    this.playVideo = this.playVideo.bind(this);
    this.startCurrentQuestion = this.startCurrentQuestion.bind(this);
    this.endCurrentQuestion = this.endCurrentQuestion.bind(this);
    this.showQuestionResults = this.showQuestionResults.bind(this);
    this.resetCurrentQuestion = this.resetCurrentQuestion.bind(this);
    this.getNextQuestion = this.getNextQuestion.bind(this);
    this.changeCurrentQuestionTo = this.changeCurrentQuestionTo.bind(this);
    this.updateCurrentQuestion = this.updateCurrentQuestion.bind(this);
  }

  componentDidMount() {
    database.ref('/General').on('value', (general) => {
      this.setState({ general: general.val() });
      database.ref('/Games/' + general.val().currentGame).on('value', (game) => {
        this.setState({ currentGame: game.val() });
      });
    });
  }


  startStopGame(value) {
    var updates = {};
    var state = value === 1 ? 'off' : 'active';
    if (state === 'active') {
      Promise.resolve ( this.changeCurrentQuestionTo(1))
      .then (()=> {this.resetCurrentQuestion});
    }
    updates['/Games/' + this.state.general.currentGame + '/status/'] = state;
    database.ref().update(updates);
  }

  startStopStream(value) {
    var updates = {};
    var state = value === 1 ? 'off' : 'active';
    updates['/General/streamStatus/'] = state;
    database.ref().update(updates);
  }

  startCurrentQuestion() {
    var self = this;
    var updates = {};
    axios.get('https://us-central1-questions-59ee6.cloudfunctions.net/app/api/time')
      .then(function (response) {
        console.log('startCurrentQuestion - question id is ' + self.state.currentGame.currentQuestionId);
        updates['/Questions/' + self.state.general.currentGame + '/' + self.state.currentGame.currentQuestionId + '/status/'] = "active";
        updates['/Questions/' + self.state.general.currentGame + '/' + self.state.currentGame.currentQuestionId + '/startTime/'] = response.data;
        database.ref().update(updates);
      })
      .catch(function (error) {
        console.log(error);
      });


  }


  endCurrentQuestion() {
    var updates = {};
    updates['/Questions/' + this.state.general.currentGame + '/' + this.state.currentGame.currentQuestionId + '/status/'] = "off";
    database.ref().update(updates);

  }

  showQuestionResults() {
    var updates = {};
    updates['/Questions/' + this.state.general.currentGame + '/' + this.state.currentGame.currentQuestionId + '/status/'] = "results";
    database.ref().update(updates);

  }

  resetCurrentQuestion() {
    var updates = {};
    updates['/Questions/' + this.state.general.currentGame + '/' + this.state.currentGame.currentQuestionId + '/status/'] = "reset";
    database.ref().update(updates);


  }

  getNextQuestion() {
    var self = this;
    database.ref('/Questions/' + self.state.general.currentGame + '/' +
      self.state.currentGame.currentQuestionId + '/num/').once('value', function (snapshot) {
        var currentQuestionNumber = snapshot.val();
        console.log('current question is ' + currentQuestionNumber);
        currentQuestionNumber++;
        if (currentQuestionNumber <= 12) {
          self.changeCurrentQuestionTo(currentQuestionNumber);
        }
      });
  }


  changeCurrentQuestionTo(questionNum) {
    var self = this;
    database.ref('/Questions/' + self.state.general.currentGame + '/').once('value', function (snapshot) {
      var updates = {};
      var arr = self.snapshotToArray(snapshot);
      console.log('current questoin id is ' + self.state.currentGame.currentQuestionId);
      updates['/Questions/' + self.state.general.currentGame + '/' + self.state.currentGame.currentQuestionId + '/status/'] = "off";
      database.ref().update(updates).then(() => {
        self.updateCurrentQuestion(arr[questionNum - 1].questionId);
      });
    });

  }

  updateCurrentQuestion(questionId) {
    var self = this;
    var updates = {};
    updates['/Games/' + self.state.general.currentGame + '/currentQuestionId/'] = questionId;
    database.ref().update(updates);
  }


  snapshotToArray(snapshot) {
    var returnArr = [];

    snapshot.forEach(function (childSnapshot) {
      var item = childSnapshot.val();
      item.key = childSnapshot.key;
      returnArr.push(item);
    });

    return returnArr;
  };

  playVideo(event) {
    if (this.refs.videoInput.value.length >= 1) {
      var updates = {};
      updates['/General/videoPlaying'] = this.state.video;
      database.ref().update(updates).then(() => {
        var updates = {};
        updates['/General/videoPlaying'] = "off";
        database.ref().update(updates)
      });
      alert('Video played: ' + this.state.video);
      this.state.video = '';
      this.refs.videoInput.value = '';
    }
    event.preventDefault();
  }




  sendMessage(event) {
    if (this.refs.messageInput.value.length >= 1) {
      var updates = {};
      updates['/General/message/'] = this.state.message;
      updates['/General/messageStatus'] = "active";
      database.ref().update(updates).then(() => {
        var updates = {};
        updates['/General/messageStatus'] = "off";
        database.ref().update(updates)
      });
      alert('Message submitted: ' + this.state.message);
      this.state.message = '';
      this.refs.messageInput.value = '';
    }
    event.preventDefault();
  }



  render() {
    return (
      <div>
        <Header pageTitle='Game' />
        <h1>Manage current game</h1>
        <h2>Current game status:</h2>
        <ToggleButton inactiveLabel='Off' activeLabel='Active' value={this.state.currentGame.status === 'active' ? 1 : 0}
          onToggle={(value) => { this.startStopGame(value); }} />
        <h2>Stream status:</h2>
        <ToggleButton inactiveLabel='Off' activeLabel='Active' value={this.state.general.streamStatus === 'active' ? 1 : 0}
          onToggle={(value) => { this.startStopStream(value); }} />
        {/* Message form */}
        <form onSubmit={this.sendMessage}>
          <label>
            Send message:
          <input type="text" ref="messageInput" onChange={(s) => this.setState({ message: s.target.value })} />
          </label>
          <input type="submit" value="Submit" />
        </form>
        {/* Video form */}
        <form onSubmit={this.playVideo}>
          <label>
            Play video:
          <input type="text" ref="videoInput" onChange={(s) => this.setState({ video: s.target.value })} />
          </label>
          <input type="submit" value="Submit" />
        </form>
        <h2>Question management</h2>
        <button onClick={this.startCurrentQuestion}>Start current</button>
        <button onClick={this.endCurrentQuestion}>End current</button>
        <button onClick={this.showQuestionResults}>Show results</button>
        <button onClick={this.resetCurrentQuestion}>Reset question</button>
        <button onClick={this.getNextQuestion}>Next question</button>
      </div>

    );
  }

}
export default Game;


// WEBPACK FOOTER //
// ./src/containers/Game.js